export function splitFileNameAndExtension(fileName: string) {
  const dotIndex = fileName.lastIndexOf('.');
  const extension = fileName.substring(dotIndex);
  fileName = dotIndex !== -1 ? fileName.substring(0, dotIndex) : fileName;

  return {
    fileName,
    extension,
  };
}

export function sanitizeStorageFileName(fileName: string): string {
  return fileName.replace(/\.\./g, '_').replace(/[/\\#[\]*?]/g, '_');
}
